<template>
	<div class="header-container">
		<div class="router-view">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item v-for="(item, index) in $route.meta" :key="index">
					<span :class="{menuNow: index === $route.meta.length-1, canClick: item.url }" class="bread"
						@click="changeRouter(item.url,index)">
						{{ item.name }}
					</span>
				</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="admin-right" @command="handleCommand">
			<el-badge :is-dot='data.is_read == 2?false:true' class="item">
				<i style="font-size: 24px;" class="el-icon-message pointer" @click="toMsg"></i>
			</el-badge>
			<el-avatar :size="'medium'" style="margin-left: 20px;"
				src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"></el-avatar>
			<el-dropdown @command="handleCommand">
				<span class="el-dropdown-link">
					{{ loginData.name }}
					<i class="el-icon-arrow-down el-icon--right" />
				</span>
				<el-dropdown-menu slot="dropdown">
					<el-dropdown-item command="signOut">
						<img src="../assets/images/logout.png" class="dk-icon-back">
						退出
					</el-dropdown-item>
				</el-dropdown-menu>
			</el-dropdown>
		</div>
	</div>
</template>

<script>
	import {
		getDesk
	} from "@/api/console"
	import Utils from '../jslibs/utils';
	import {
		mapState,
		mapMutations
	} from "vuex";
	import CommonDialog from "@/components/CommonDialog";
	import {
		editAuthUser,
		getAuthListDetail
	} from "@/api/auth";
	import {
		getSetting,
		changeSetting
	} from "@/api/common";

	export default {
		data() {
			return {
				dialogVisible: false,
				form: {},
				formLabelWidth: "120px",
				needQuery: [], //需要参数的第二个面包屑
				dialogTitle: "编辑管理员",
				dialogType: "",
				isMessage: false,
				isWallet: false,
				settingInfo: {},
				data: ''
			};
		},
		components: {
			CommonDialog
		},
		computed: {
			...mapState(["loginData", "id"])
		},
		watch: {},
		mounted() {
			this.getDesk()
		},
		methods: {
			...mapMutations(["updateLoginData", "update_id"]),
			changeRouter(url, index) {
				if (url) {
					const meta = this.$route.meta;
					//index length
					//1 3  2 4  3 5
					//1 4 1 5  2 5
					//index + 1 - length
					this.$router.go(index + 1 - meta.length);
					// //不需要传参数
					// if ((meta.length <= 3 && !this.needQuery.includes(meta[index].name)) || index < 2) {
					//   this.$router.push({ path: url });
					// } else {
					//   //需要传参去页面中传参跳转
					//   this.bus.$emit('navigate', index)
					// }
				}
			},
			onChangePasswordClick() {
				console.log("change");
			},
			handleCommand(command) {
				switch (command) {
					case "signOut":
						sessionStorage.setItem("permission", "")
						Utils.setCookie("authorization", "");
						this.$router.push({
							path: "/login"
						});
						break;
				}
			},
			async getDesk() {
				const {
					status,
					data
				} = await getDesk();
				if (status !== 200) return;
				this.data = data.result
			},
			toMsg(){
				this.$router.push({
					path:'/message-list'
				})
				this.getDesk()
			},
		}
	};
</script>

<style lang="less">
	@import "~@/assets/styles/variables.less";

	.header-container {
		padding: 0 57px 0 30px;
		height: 73px;
		display: flex;
		justify-content: space-between;
		align-items: center;
		background: #fff;
		margin: 0;
		width: calc(100vw - 200px);
		width: -webkit-calc(100vw - 200px);
		width: -moz-calc(100vw - 300px);
		position: fixed;
		border-bottom: 1px solid #e5e5e5;
		z-index: 2;

		.search-row {
			width: 100%;
		}

		.router-view {
			/deep/.el-breadcrumb {
				line-height: 20px;
			}

			.menuNow {
				font-family: PingFangSC-Semibold, PingFang SC;
				font-weight: 600;
			}

			.canClick {
				cursor: pointer;
			}

			.canClick:hover {
				color: @main-color;
			}

			.bread {
				font-size: 14px;
				color: #000;
			}
		}

		.filter-view {
			display: flex;
			padding-right: 25px;
			align-items: center;

			.type {
				margin: 0 10px;
				color: #223040;
				background: rgba(0, 0, 0, 0);
				margin: 0 15px;
			}
		}

		.admin-right {
			height: 100%;
			display: flex;
			align-items: center;

			.admin-head {
				width: 32px;
				height: 32px;
				border-radius: 50%;
				margin-right: 12px;
			}

			.setting {
				margin-right: 20px;
			}

			.el-dropdown-link {
				font-size: 14px;
				margin-left: 10px;
				color: #000;
			}
		}
	}

	.dk-icon-back {
		display: inline-block;
		width: 14px;
		height: 14px;
		margin: 12px 12px 0 0;
	}

	.top-search-input {
		width: 220px;
		margin: 0 10px;

		.search-icon {
			width: 36px !important;
			height: 36px !important;
			padding: 10px 11px !important;
		}

		.search-row {
			margin-bottom: 30px;
		}
	}

	.dialog-body-wrap {
		.item {
			margin-bottom: 20px;
		}
	}
</style>